import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const codelistQuery = createApi({
  baseQuery,
  reducerPath: "codelistQueries",
  endpoints: (builder) => ({
    getCodelistValue: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.codelist.getCodelist)}`,
        method: "POST",
        body: data,
      }),
    }),
    getCodelistLibrary: builder.mutation<any, any>({
      query: ({
        from = 0,
        size = -1,
        value = "",
        sort_by = "",
        sort_order = "",
        is_audit = false,
        data,
      }) => ({
        url: `${formatString(
          endPoints.codelist.codelistLib
        )}?from=${from}&size=${size}&is_audit=${is_audit}${
          value && `&value=${encodeURIComponent(value)}`
        }${sort_by && `&sort_by=${sort_by}`}${
          sort_order && `&sort_order=${sort_order}`
        }`,
        method: "POST",
        body: data,
      }),
    }),
    getCodelistValueCodes: builder.mutation<any, any>({
      query: ({
        code_list_code,
        from = 0,
        size = -1,
        value = "",
        sort_by = "",
        sort_order = "",
        is_audit = false,
        data,
      }) => ({
        url: `${formatString(endPoints.codelist.codelistValues, {
          key: urlKeys.code_list_code,
          value: encodeURIComponent(code_list_code),
        })}?from=${from}&size=${size}&is_audit=${is_audit}&${
          value && `&value=${encodeURIComponent(value)}`
        }${sort_by && `&sort_by=${sort_by}`}${
          sort_order && `&sort_order=${sort_order}`
        }`,
        method: "POST",
        body: data,
      }),
    }),
    createCodelistValues: builder.mutation<any, any>({
      query: ({ data, code_list_code }) => ({
        url: `${formatString(endPoints.codelist.createCodelistValues, {
          key: urlKeys.code_list_code,
          value: encodeURIComponent(code_list_code),
        })}`,
        method: "POST",
        body: data,
      }),
    }),
    updateCodelistValues: builder.mutation<any, any>({
      query: ({ data, code_list_code }) => ({
        url: `${formatString(endPoints.codelist.updateCodelistValues, {
          key: urlKeys.code_list_code,
          value: encodeURIComponent(code_list_code),
        })}`,
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetCodelistValueMutation,
  useGetCodelistLibraryMutation,
  useGetCodelistValueCodesMutation,
  useCreateCodelistValuesMutation,
  useUpdateCodelistValuesMutation,
} = codelistQuery;
